// extracted by mini-css-extract-plugin
export default {"deleteBtn":"DeleteGraduate_deleteBtn__Tgoeg"};